import { Colors, Img, Lightning, Utils } from '@lightningjs/sdk'
import { isFilledObject } from '../../lib/AppHelpers'
import { appSettings } from '../../lib/AppSettings'

export default class ArtistCover extends Lightning.Component {
  static _template() {
    return {
      CoverWrapper: {
        w: 350,
        h: 350,
        pivotX: 1,
        pivotY: 0.5,
        CoverImageWrapper: {
          w: 350,
          h: 350,
          clipping: true,
          CoverBG: { w: 350, h: 350 },
          ArtistCover: { w: 350, h: 350 },
        },
      },
      TitleWrapper: {
        y: 260,
        x: 20,
        Title: {
          color: Colors('white').get(),
          text: {
            text: this.bindProp('coverTitle'),
            fontSize: 25,
            fontFace: 'OpenSansSemibold',
            wordWrap: false,
            textOverflow: 'ellipsis',
            wordWrapWidth: 310,
            maxLines: 1,
          },
        },
        Artist: {
          y: 40,
          color: Colors('white').get(),
          text: {
            text: this.bindProp('coverArtist'),
            fontSize: 22,
            fontFace: 'OpenSansLight',
            wordWrap: false,
            textOverflow: 'ellipsis',
            wordWrapWidth: 310,
          },
        },
      },
      PlayButton: {
        x: 128,
        y: 128,
        w: 100,
        h: 100,
        scale: 0.65,
        src: Utils.asset('images/playerbuttons/playButton100n.png'),
      },
    }
  }

  set item(itm) {
    this._item = itm
    this._fillWrapper()
  }

  get item() {
    return this._item
  }

  set isOnActiveWrapper(bool) {
    this._isOnActiveWrapper = bool
  }

  _init() {
    this._isOnActiveWrapper = false

    this.focusAnimation = this.animation({
      duration: 0.4,
      repeat: 0,
      stopMethod: 'reverse',
      stopDuration: 0.3,
      actions: [
        { t: 'CoverWrapper', p: 'scale', v: { 0: 1, 1: 1.65 } },
        { t: 'TitleWrapper', p: 'w', v: { 0: 310, 1: 530 } },
        { t: 'TitleWrapper', p: 'x', v: { 0: 20, 1: -190 } },
        { t: 'TitleWrapper', p: 'y', v: { 0: 260, 1: 335 } },
        { t: 'Title', p: 'text.fontSize', v: { 0: 25, 1: 35 } },
        { t: 'Title', p: 'text.wordWrapWidth', v: { 0: 310, 1: 530 } },
        { t: 'Artist', p: 'text.fontSize', v: { 0: 22, 1: 25 } },
        { t: 'Artist', p: 'text.wordWrapWidth', v: { 0: 310, 1: 530 } },
        { t: 'Artist', p: 'y', v: { 0: 40, 1: 60 } },
        { t: 'PlayButton', p: 'x', v: { 0: 128, 1: 15 } },
        { t: 'PlayButton', p: 'y', v: { 0: 128, 1: 130 } },
        { t: 'PlayButton', p: 'scale', v: { 0: 0.65, 1: 1 } },
      ],
    })

    this.focusAnimation.on('finish', () => {
      if (this.tag('CoverWrapper').scale > 1) {
        this.signal('CoverFocusDone')
      }
    })
  }

  set isCurrentyPlaying(v) {
    this._playerState = v ? ArtistCover.PLAYINGSTATE : ArtistCover.STOPSTATE
    this.tag('PlayButton').src = Utils.asset(
      `images/playerbuttons/${v ? ArtistCover.STOPSTATE : ArtistCover.PLAYSTATE}Button100n.png`
    )
  }
  onRadioMessage() {
    this._fillWrapper()
  }
  OnGpStateChange({ playbuttonState }) {
    this._playerState = playbuttonState.toLowerCase()
    this.tag('PlayButton').src = Utils.asset(
      `images/playerbuttons/${
        this._playerState === ArtistCover.STOPSTATE ? ArtistCover.PLAYSTATE : ArtistCover.STOPSTATE
      }Button100f.png`
    )
  }

  _fillWrapper() {
    const artist = appSettings.nowPlaying.currentPlaying,
      station = appSettings.nowPlaying.currentShow,
      coverTitle = isFilledObject(artist) && artist.title ? artist.title : '',
      coverArtist = isFilledObject(artist) && artist.artist ? artist.artist : '',
      showOverlay = isFilledObject(artist) && artist.title ? 1 : 0
    let artistImg
    if ((artist && artist.type === 'show') || artist.type === 'track') {
      artistImg = artist && artist.image && artist.image > '' ? artist.image : station.image
    } else {
      artistImg = this._item.image
    }
    this.tag('ArtistCover').texture = Img(artistImg).landscape(350 / 2) // todo resize to original
    this.tag('CoverBG').texture = Img(this._item.imageBg).cover(350 / 2, 350 / 2) // todo resize to original
    this.patch({ coverTitle, coverArtist, showOverlay })
  }

  _focus() {
    this.focusAnimation.start()
    this.tag('PlayButton').src = Utils.asset(
      `images/playerbuttons/${
        this._playerState === ArtistCover.PLAYINGSTATE ? 'stopButton100f.png' : 'playButton100f.png'
      } `
    )
  }

  _unfocus() {
    this.focusAnimation.stop()
    this.tag('PlayButton').src = Utils.asset(
      `images/playerbuttons/${
        this._playerState === ArtistCover.PLAYINGSTATE ? 'stopButton100n.png' : 'playButton100n.png'
      } `
    )
  }
}

ArtistCover.PLAYINGSTATE = 'playing'
ArtistCover.PLAYSTATE = 'play'
ArtistCover.STOPSTATE = 'stop'
